import { createFileRoute } from '@tanstack/react-router'
import { EditVetPage } from '_/features/pets/ui/pages/edit-vet-page'

const EditVetRoute = () => {
	const { vetId } = Route.useParams()
	return <EditVetPage vetId={vetId} />
}

export const Route = createFileRoute('/_authenticated/pets/vets/$vetId/edit')({
	staticData: { title: 'vets_edit_title' },
	component: EditVetRoute,
})
